<!--
 * @Description: 
 * @Author: yuxin
 * @Date: 2024-12-10 09:56:00
 * @LastEditors: Do not edit
 * @LastEditTime: 2025-07-04 10:17:01
 * @FilePath: \mgr_web\src\views\contentCenter\index.vue
-->
<!-- 
 * @author song
 * @since 2022-04-21
 * @publisher  宏脉信息技术（广州）股份有限公司
 -->
<template>
  <div v-loading="loadingSuccess">
    <!-- 旧商城 -->
    <el-tabs
      v-model="activeName"
      @tab-click="handleClick"
      v-if="currentMallType != 1 && !loadingSuccess"
    >
      <el-tab-pane label="商品统计" name="first" v-if="roleObj.sptj">
      </el-tab-pane>
      <el-tab-pane
        label="券统计"
        name="second"
        v-if="roleObj.xfqtj && currentSysm != 2 && currentSysm != 3"
      >
      </el-tab-pane>
      <el-tab-pane
        label="员工统计"
        name="third"
        v-if="roleObj.ygtj && currentSysm != 2 && currentSysm != 3"
      >
      </el-tab-pane>
      <Statistics v-if="activeName === 'first' && roleObj.sptj"></Statistics>
      <ConsumerCoupon
        v-if="
          activeName === 'second' &&
            roleObj.xfqtj &&
            currentSysm != 2 &&
            currentSysm != 3
        "
      ></ConsumerCoupon>
      <Employee
        v-if="
          activeName === 'third' &&
            roleObj.ygtj &&
            currentSysm != 2 &&
            currentSysm != 3
        "
      ></Employee>
      <el-empty
        v-if="!roleObj.sptj && !roleObj.xfqtj && !roleObj.ygtj"
        :image-size="400"
        description="您暂无权限查看，请联系管理员增加权限"
      ></el-empty>
    </el-tabs>
    <!-- 新商城 -->
    <el-tabs
      v-model="activeName"
      @tab-click="handleClick"
      v-if="currentMallType == 1 && !loadingSuccess"
    >
      <el-tab-pane label="商品统计" name="first" v-if="roleObj.sptj">
      </el-tab-pane>
      <el-tab-pane label="活动统计" name="second"> </el-tab-pane>
      <el-tab-pane label="领券统计" name="third"> </el-tab-pane>
      <GoodsStatistics v-if="activeName === 'first' && roleObj.sptj" />
      <ActivityStatistics v-if="activeName === 'second'" />
      <GetGouponsStatistics v-if="activeName === 'third'" />
      <!-- <Statistics v-if="activeName === 'first' && roleObj.sptj"></Statistics>
      <ConsumerCoupon
        v-if="
          activeName === 'second' &&
            roleObj.xfqtj &&
            currentSysm != 2 &&
            currentSysm != 3
        "
      ></ConsumerCoupon>
      <Employee
        v-if="
          activeName === 'third' &&
            roleObj.ygtj &&
            currentSysm != 2 &&
            currentSysm != 3
        "
      ></Employee> -->
      <!-- <el-empty
        v-if="!roleObj.sptj && !roleObj.xfqtj && !roleObj.ygtj"
        :image-size="400"
        description="您暂无权限查看，请联系管理员增加权限"
      ></el-empty> -->
    </el-tabs>
  </div>
</template>
<script>
import Statistics from "./statistics/index.vue";
/** 新商城 活动统计 */
import ActivityStatistics from "./newMall/activityStatistics/index.vue";
/** 新商城 券统计 */
import GetGouponsStatistics from "./newMall/getGouponsStatistics/index.vue";
/** 新商城 商品统计 */
import GoodsStatistics from "./newMall/goodsStatistics/index.vue";
import ConsumerCoupon from "./consumerCoupon/index.vue";
import Employee from "./employee/index.vue";
import { getCheckSystemApi } from "@/api/index.js";
/** 检查新旧商城 0： 旧商城 1： 新商城 默认新商城 1 */
import { checkMallSysApi } from "@/api/contentCenter/Statistics";
export default {
  name: "contentCenter",
  data() {
    return {
      activeName: "first",
      roleObj: {
        sptj: false,
        xfqtj: false,
        ygtj: false,
      },
      /** 当前系统 0经典;  1云医美1.0； 2云医美4.0； 3客云 */
      currentSysm: 0,
      /** 新旧商城标识  0： 旧商城 1： 新商城 默认新商城 1*/
      currentMallType: 1,
      /** 是否加载成功 */
      loadingSuccess: true,
    };
  },
  components: {
    Statistics,
    ConsumerCoupon,
    Employee,
    /** 新商城商品统计 */
    GoodsStatistics,
    /** 新商城活动统计 */
    ActivityStatistics,
    /** 新商城券统计 */
    GetGouponsStatistics,
  },
  computed: {
    btnAuthority() {
      return this.$store.state.tagsView.roleAuthrority;
    },
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    },

    /** 获取当前系统 */
    getCheckSystem() {
      getCheckSystemApi().then((res) => {
        console.log("res++++", res.error.code == 200);
        if (res && res.error && res.error.code == 200 && res.data) {
          this.currentSysm = res.data.code || null;
        }
      });
    },

    /** 获取新、旧商城标识 */
    getNewOrOldMallFlag(corpId) {
      this.loadingSuccess = true;
      checkMallSysApi(corpId, localStorage.getItem("Authorization")).then(
        (res) => {
          console.log("111", res);
          if (res && res.error.code == 200) {
            this.currentMallType = res.data == null ? 1 : res.data;
          }
          console.log("fgdgfdgfdg", this.currentMallType);
          this.loadingSuccess = false;
        }
      );
    },
  },
  watch: {
    btnAuthority: {
      handler(newVal, oldVal) {
        if (newVal.length > 0) {
          newVal.forEach((item) => {
            if (item.pname == "商品统计") {
              let senBtnAuthority = item.cfunBu;
              console.log("权限控制---", senBtnAuthority, this.roleObj);
              senBtnAuthority.forEach((item) => {
                this.roleObj[item] = true;
              });
            }
          });
        }
      },
      deep: true,
      immediate: true,
    },
    roleObj: {
      handler(newVal, oldVal) {
        console.log("数据发生了改变XXX", newVal, oldVal);
        if (newVal.sptj) {
          this.activeName = "first";
        }
        if (!newVal.sptj && newVal.xfqtj) {
          this.activeName = "second";
        }
        if (!newVal.sptj && !newVal.xfqtj && newVal.ygtj) {
          this.activeName = "third";
        }
      },
      deep: true,
      immediate: true,
    },
  },

  /** 生命周期 */

  created() {
    /** 获取corpid */
    let enterpriseData = JSON.parse(
      window.localStorage.getItem("enterpriseData")
    );

    /** 获取新旧商城标识 */
    this.getNewOrOldMallFlag(enterpriseData.corpid);

    /** 获取系统标识 */
    this.getCheckSystem();
  },
};
</script>

<style></style>
